import React from 'react';
import { AlertCircle } from 'lucide-react';
import { useLanguage } from '../../../contexts/LanguageContext';

export const WarningMessage = () => {
  const { translations } = useLanguage();

  return (
    <div className="flex items-start gap-3 bg-yellow-50 text-yellow-700 p-4 rounded-lg">
      <AlertCircle className="shrink-0 mt-0.5" size={20} />
      <div className="text-sm">
        <p className="font-medium">
          {translations?.warningMessage?.title || 'Important Warning'}
        </p>
        <p>
          {translations?.warningMessage?.message ||
            'Make sure that the file follows the required template. It must contain the following columns:'}
        </p>
        <ul className="mt-2 list-disc list-inside">
          <li>
            {translations?.warningMessage?.columns?.roomNumber ||
              'Room Number'}
          </li>
          <li>
            {translations?.warningMessage?.columns?.bedIndex ||
              'Bed Index'}
          </li>
          <li>
            {translations?.warningMessage?.columns?.passportNumber ||
              'Passport Number'}
          </li>
        </ul>
      </div>
    </div>
  );
};